var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Detalle Tipo de Ubicación" },
          on: { cerrar: _vm.handlePopUp }
        },
        [
          _c("div", { staticClass: "numero_sim" }, [
            _c(
              "div",
              { staticClass: "btn-editar" },
              [
                _c("v-btn", { on: { click: _vm.handleAdd } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        Object.keys(_vm.data).length === 0
                          ? "Guardar"
                          : "Guardar Cambios"
                      ) +
                      "\n        "
                  )
                ])
              ],
              1
            )
          ])
        ]
      ),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c("br"),
      _c(
        "div",
        { attrs: { align: "center" } },
        [
          _c(
            "v-flex",
            { attrs: { md10: "" } },
            [
              _c(
                "v-card",
                { staticClass: "rounded-card" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      staticClass: "col-md-12",
                      attrs: { "lazy-validation": "" }
                    },
                    [
                      _c(
                        "v-container",
                        {
                          attrs: {
                            "grid-list-md": "",
                            "pt-30": "",
                            "px-40": "",
                            "pb-50": ""
                          }
                        },
                        [
                          _c(
                            "FormFieldsContainer",
                            {
                              attrs: {
                                titulo:
                                  Object.keys(_vm.data).length === 0
                                    ? "Crear Tipo de Ubicación"
                                    : "Editar Tipo de Ubicación"
                              }
                            },
                            [
                              _vm._t("prependInformacionGeneral"),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    class: { "red--text": _vm.invalidate },
                                    attrs: {
                                      label: _vm.formFields.tipoubicaname.label,
                                      error: _vm.invalidate,
                                      disabled: _vm.anulado
                                    },
                                    on: { input: _vm.validateTipoubicaName },
                                    model: {
                                      value: _vm.formFields.tipoubicaname.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.tipoubicaname,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.tipoubicaname.value"
                                    }
                                  }),
                                  _vm.invalidate
                                    ? _c(
                                        "div",
                                        { staticClass: "alerta--error" },
                                        [
                                          _c("span", [_vm._v("*")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.messageError) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label:
                                        _vm.formFields.tipoubicafecha_alta
                                          .label,
                                      disabled: ""
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.tipoubicafecha_alta
                                          .value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.tipoubicafecha_alta,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.tipoubicafecha_alta.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      label: _vm.formFields.tipoubicabaja.label,
                                      items: _vm.opciones,
                                      "item-text": "value",
                                      "item-value": "id",
                                      disabled:
                                        Object.keys(_vm.data).length === 0
                                    },
                                    model: {
                                      value: _vm.formFields.tipoubicabaja.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.tipoubicabaja,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.tipoubicabaja.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              Object.keys(_vm.data).length > 0
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm12: "", md12: "" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          label: "Usuarios",
                                          items: _vm.listaUsers,
                                          disabled: _vm.anulado,
                                          "item-text": "nombre_completo",
                                          "item-value": "id",
                                          "item-key": "id",
                                          multiple: "",
                                          chips: ""
                                        },
                                        model: {
                                          value: _vm.listaUsersSave,
                                          callback: function($$v) {
                                            _vm.listaUsersSave = $$v
                                          },
                                          expression: "listaUsersSave"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogPopUp,
          titulo: "Confirmación",
          mensaje:
            "Al cerrar esta ventana toda la información\n      " +
            (Object.keys(_vm.data).length === 0 ? "ingresada" : "editada") +
            "\n      se perderá.\n      ¿Está seguro que desea cerrar sin guardar?",
          textoBtnSi: _vm.$t("No Guardar"),
          textoBtnNo: _vm.$t(
            "" +
              (Object.keys(_vm.data).length === 0
                ? "Continuar Creando"
                : "Continuar Editando")
          )
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.showPopUp($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }